import { Box, FormControl, MenuItem, Select, SelectChangeEvent } from "@mui/material"
import { useCallback, useEffect, useState } from "react";

type MenuItemType<K extends string = string> = {
    key: K,
    label: string,
    condition?: boolean
}
const SessionFilterOptions: MenuItemType[] = [
    { key: "ALL", label: "All Records" },
    { key: "ENGLISH_TWEEN_SCREEN", label: "English TweenScreen" },
    // { key: "ES_TWS", label: "Spanish TweenScreen" },
    { key: "ENGLISH_T_SCREEN", label: "English tScreen" },
    // { key: "ES_TSN", label: "Spanish tScreen" },
    // { key: "EN_TNSN", label: "English TeenScreen" },
    // { key: "ES_TNSN", label: "Spanish TeenScreen" }
    { key: "BOOLEAN", label: "Boolean Questions", condition: true },
    { key: "SCALE", label: "Scale Questions", condition: true },
    { key: "FREEFORM", label: "Freeform Questions", condition: true },
    { key: "MULTISELECT", label: "Multiselect", condition: true }
] as const;

const ChildrenFilterOptions: MenuItemType[] = [
    { key: "ALL", label: "All Records" },
    { key: "ACTIVE", label: "Active Only" },
    { key: "EXPIRED", label: "Expired Only" },
    { key: "TSCREEN_AGE", label: "Kids ages 5-9", condition: true },
    { key: "TWEEN_AGE", label: "Kids ages 10-13", condition: true },
    { key: "TEEN_AGE", label: "Kids ages 14+", condition: true },
    { key: "CONSENT_GIVEN", label: "Received Consent", condition: true },
    { key: "CONSENT_BY_DEFAULT", label: "Consent by Default", condition: true },
    { key: "CONSENT_PENDING", label: "Consent Pending", condition: true },
    { key: "CONSENT_REJECTED", label: "Consent Rejected", condition: true }

] as const;
const StandardFilterOptions: MenuItemType[] = [
    { key: "ALL", label: "All Records" },
    { key: "ACTIVE", label: "Active Only" },
    { key: "EXPIRED", label: "Expired Only" }
] as const;

export type SessionFilterOption = typeof SessionFilterOptions[number]["key"];

export type ChildrenFilterOption = typeof ChildrenFilterOptions[number]["key"];
export type StandardFilterOption = typeof StandardFilterOptions[number]["key"];

export type CombinedFilterOption = SessionFilterOption | StandardFilterOption | ChildrenFilterOption;
export type TableName = "sessions" | "standard" | "children"

export type TableToFilterOptionMap = {
    sessions: SessionFilterOption,
    standard: StandardFilterOption
    children: ChildrenFilterOption
}

const filterOptionsMap = {
    sessions: SessionFilterOptions,
    standard: StandardFilterOptions,
    children: ChildrenFilterOptions
} as const

// function getFilterOptions<T extends keyof typeof filterOptionsMap>(
//     table: T
// ): readonly MenuItemType<TableToFilterOptionMap[T]>[] {
//     return filterOptionsMap[table];
// }
function getFilterOptions<T extends keyof typeof filterOptionsMap>(
    table: T
): typeof filterOptionsMap[T] {
    return filterOptionsMap[table];
}


export type TableFilterProps<T extends TableName> = {
    tableName: T,
    defaultValue?: TableToFilterOptionMap[T],
    onChange?: (value: TableToFilterOptionMap[T]) => void
    limitFilter?: boolean,
}

export default function TableFilter<T extends TableName>({
    tableName,
    defaultValue,
    limitFilter,
    onChange }: TableFilterProps<T>) {
    const filterOptions = getFilterOptions(tableName);
    const [selectedOption, setSelectedOption] = useState<TableToFilterOptionMap[T]>(defaultValue ?? filterOptions[0].key);

    useEffect(() => {
        onChange?.(selectedOption);
    }, [selectedOption]);

    const handleSelectionChange = (event: SelectChangeEvent) => {
        const selectedValue = event.target.value as TableToFilterOptionMap[T];
        setSelectedOption(selectedValue);
    }
    return (
        <Box component="span">
            <FormControl fullWidth>
                <Select
                    id="table-filter"
                    value={selectedOption}
                    defaultValue={defaultValue ?? "ALL"}
                    onChange={handleSelectionChange}
                    sx={{ height: "40px" }}
                >
                    {filterOptions.filter(opt => limitFilter ? opt.condition === undefined : opt)
                        .map((opt: any) => (
                            <MenuItem key={opt.key} value={opt.key}>
                                {opt.label}
                            </MenuItem>
                        ))}
                    {/* {filterOptions
                        .map((opt: any) => (
                            <MenuItem key={opt.key} value={opt.key}>
                                {opt.label}
                            </MenuItem>
                        ))} */}
                </Select>
            </FormControl>
        </Box>
    )
}